import { SVGProps } from "react";

/**
 * Group of people — used for attendee/visitor counts.
 *
 * @remarks
 * Distinct from `GroupIcon`, which is the design-tool grouping icon.
 */
export default function PeopleGroupIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, stroke = "#333333", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M15.0004 5.96675C14.9504 5.95842 14.8921 5.95842 14.8421 5.96675C13.6921 5.92508 12.7754 4.98342 12.7754 3.81675C12.7754 2.62508 13.7337 1.66675 14.9254 1.66675C16.1171 1.66675 17.0754 2.63342 17.0754 3.81675C17.0671 4.98342 16.1504 5.92508 15.0004 5.96675Z"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1422 12.0333C15.2839 12.225 16.5422 12.025 17.4255 11.4333C18.6005 10.65 18.6005 9.36664 17.4255 8.58331C16.5339 7.99164 15.2589 7.79163 14.1172 7.99163"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.97344 5.96675C5.02344 5.95842 5.08177 5.95842 5.13177 5.96675C6.28177 5.92508 7.19844 4.98342 7.19844 3.81675C7.19844 2.62508 6.24011 1.66675 5.04844 1.66675C3.85677 1.66675 2.89844 2.63342 2.89844 3.81675C2.90677 4.98342 3.82344 5.92508 4.97344 5.96675Z"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83255 12.0333C4.69088 12.225 3.43255 12.025 2.54922 11.4333C1.37422 10.65 1.37422 9.36664 2.54922 8.58331C3.44089 7.99164 4.71588 7.79163 5.85755 7.99163"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0004 12.1916C9.95039 12.1833 9.89206 12.1833 9.84206 12.1916C8.69206 12.1499 7.77539 11.2083 7.77539 10.0416C7.77539 8.84994 8.73372 7.8916 9.92539 7.8916C11.1171 7.8916 12.0754 8.85827 12.0754 10.0416C12.0671 11.2083 11.1504 12.1583 10.0004 12.1916Z"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4246 14.8166C11.0996 13.9332 8.90794 13.9332 7.57461 14.8166C6.39961 15.5999 6.39961 16.8832 7.57461 17.6666C8.90794 18.5582 11.0913 18.5582 12.4246 17.6666"
        stroke={stroke}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
